import { RichText } from 'prismic-reactjs';
import ArticleMeta from './ArticleMeta';
import { IArticleHeaderProps } from './interfaces';
import { Routes } from '../../../models/enums/routes';
import { ArticleHeaderLink, ArticleHeaderLinkH1 } from './styles';

const ArticleHeader = (props: IArticleHeaderProps) => {
  return (
    <div className={`${props.className}-header`}>
      {props.titleIsLink ? (
        <ArticleHeaderLink
          href={`${Routes.InsightsArticleId}${RichText.asText(props.seo_url)}`}
        >
          {RichText.asText(props.title)}
        </ArticleHeaderLink>
      ) : (
        <ArticleHeaderLinkH1 className={'article-header__title'}>
          {RichText.asText(props.title)}
        </ArticleHeaderLinkH1>
      )}
      <ArticleMeta
        className={props.className}
        author={props.author}
        publishDate={props.publishDate}
        tags={props.tags}
        authorImage={props.authorImage}
      />
    </div>
  );
};

export default ArticleHeader;
